module.exports = __webpack_public_path__ + "static/img/6.f9e4614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zz/6.png
// module id = V8Di
// module chunks = 1